module.exports = __webpack_public_path__ + "assets/5f2491b03c11f6ac444f70e6aa922cf4.mp3";